module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/owners/css/owner-crud.component.css
// module id = ./src/app/modules/owners/css/owner-crud.component.css
// module chunks = main